import React from 'react';
import { createRoot } from 'react-dom/client';
import './globals.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// パフォーマンスを測定する場合は、結果を
// 関数に渡して記録したり、
// たとえば: reportWebVitals(console.log)
// または分析エンドポイントに送信したりします。
// 詳細: https://bit.ly/CRA-vitals
reportWebVitals();
